import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Input,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import PhoneInput from "react-phone-input-2";
// import { useLazyGetSpecificAgentByIdQuery } from "../../services/agents";
import { UploadMedia } from "../../utils/uploadMedia";
import {
  errorToast,
  getFromStorage,
  STORAGE_KEYS,
  successToast,
} from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { Agent, CommonBody } from "../../types/General";
// import {
//   useAddUserApiMutation,
//   useEditUserMutation,
//   useLazyGetPendingCompanyQuery,
// } from "../../services/users";
import Loader from "../../helpers/constants/Loader";
import { Autocomplete } from "@react-google-maps/api";
import { Autocomplete as MUIAutocomplete } from "@mui/material";
import {
  useCustomerByIdMutation,
  useUpdateVendorByOIdMutation,
} from "../../services/registration";
import useTranslation from "../../hooks/Translation";

const INDUSTRY_TYPE = [
  { value: "1", label: "Retailer" },
  { value: "2", label: "Wholesaler" },
  { value: "3", label: "Distributer" },
];
const ProfileSetup = () => {
  const t = useTranslation();
  const [dialCode, setPhoneCode] = useState("+971");
  const [imageId, setImageId] = useState(null);
  const [error, setError] = useState(false);
  const [fetchApi] = useCustomerByIdMutation();
  const [profile_picture, setProfilePicture] = useState("");
  const [ByIdDetails, setByIdDetails] = useState<any>();
  const navigate = useNavigate();
  const [editVendorByiD] = useUpdateVendorByOIdMutation();
  const [autocomplete, setAutocomplete] = useState<any>();
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const { id } = useParams();
  // const [fetchApi, { isLoading }] = useLazyGetSpecificAgentByIdQuery();
  // const [addUser] = useAddUserApiMutation();
  // const [companyListingApi] = useLazyGetPendingCompanyQuery();
  const [companyListing, setCompanyListing] = useState<any>([]);
  const [companyId, setCompanyId] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const fetchCompanyListing = async () => {
    try {
      // const res = await companyListingApi({
      //   page: 1,
      //   search: "",
      //   limit: 100,
      //   range: { from: "", to: "" },
      //   isAdminAprooved: 2,
      // }).unwrap();
      // if (res?.status === 200) {
      //   setCompanyListing(res?.data?.user);
      // }
    } catch (error: any) {
      console.log(error?.data?.message);
    }
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        formik.setFieldValue("profile_picture", "");
        setProfilePicture("");
        setImageId(null); // Reset if no file is selected
        return;
      }

      setIsLoading(true);
      const res = await UploadMedia(file);
      if (res?.status === 200) {
        setIsLoading(false);
        setImageId(res?.data[0]?.id); // Correctly set the image ID
        const imageUrl = res?.data[0]?.media_url;
        formik.setFieldValue("profile_picture", imageUrl); // Update Formik field
        setProfilePicture(imageUrl); // Set preview URL
        successToast("Image uploaded successfully.");
      } else {
        errorToast(res?.message); // Show error message
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setIsLoading(false);
      errorToast("Error uploading image. Please try again.");
      setImageId(null); // Reset ID in case of failure
    }
  };
  const onLoad = (autocompleteObj: any) => {
    setAutocomplete(autocompleteObj);
  };
  const onPlaceChanged = async () => {
    if (autocomplete) {
      let place = await (autocomplete as any).getPlace();

      if (place && place.address_components) {
        let address = place.address_components;

        let state,
          city,
          country,
          zip = "";

        address.forEach(function (component: any) {
          let types = component.types;

          if (
            types.indexOf("locality") > -1 ||
            types.indexOf("administrative_area_level_3") > -1
          ) {
            city = component.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        formik.setFieldValue("address", place?.formatted_address);
        formik.setFieldValue("latitude", lat || "");
        formik.setFieldValue("longitude", lng || "");
      }
    }
  };
  const fetchDataById = async (id: any) => {
    try {
      setIsLoading(true);
      const response = await fetchApi({ id: id }).unwrap();
      if (response.status === 200) {
        setByIdDetails(response?.data || []);
        setPhoneCode(response?.data?.dialCode || "");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDataById(id);
    }
  }, [id]);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      address: "",
      dialCode: dialCode,
      profile_picture: profile_picture,
      businessName: "",
      pin_code: "",
      city: "",
      industry_type: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(t.error.required),
      email: Yup.string()
        .required(t.error.emailReq)
        .matches(
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          t.error.validEmail
        )
        .matches(
          /^[^\uD800-\uDBFF\uD800-\uDBFF]+$/, // Regex to disallow emojis
          t.error.noEmoji
        ),
      phone: Yup.string().required(t.error.required),
      address: Yup.string().required(t.error.required),
      businessName: Yup.string().required(t.error.required),
      pin_code: Yup.string().required(t.error.required),
      city: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      if (!formik.isValid) return;
      const body = {
        full_name: values.name || "",
        business_name: values.businessName || "",
        city: values.city || "",
        business_address: values.address || "",
        pin_code: values.pin_code || "",
        profile_picture: imageId || null,
        industry_type: values?.industry_type || "",
      };

      if (id) {
        try {
          // const response = await editVendorByiD({
          //   id,
          //   body,
          // }).unwrap();
          const response = await editVendorByiD({ id, body }).unwrap();
          if (response?.status === 200) {
            successToast(response?.message || "Vendor updated successfully");
            navigate("/manage-vendors");
          }
        } catch (error: any) {
          errorToast(error?.data?.message);
        } finally {
          setSubmitting(false);
        }
      }
    },
  });

  useEffect(() => {
    if (id) {
      fetchDataById(id);
    }
  }, [id]);

  useEffect(() => {
    fetchCompanyListing();
  }, []);

  useEffect(() => {
    if (ByIdDetails) {
      formik.setValues({
        name: ByIdDetails?.full_name || "",
        email: ByIdDetails?.email || "",
        phone: ByIdDetails?.phone_no || "",
        profile_picture: ByIdDetails?.profile_picture?.media_url || "",
        dialCode: ByIdDetails?.country_code || dialCode,
        // companyName: "",
        address: ByIdDetails?.address?.business_address || "",
        pin_code: ByIdDetails?.address?.pin_code || "",
        businessName: ByIdDetails?.business_name || "",
        city: ByIdDetails?.address?.city || "",
        industry_type: ByIdDetails?.industry_type || "",
      });
    }
  }, [ByIdDetails]);

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country?.dialCode, ""));
    setPhoneCode(
      country?.dialCode.includes("+") ? "" : "+" + country?.dialCode
    );
  };

  return (
    <div className="main_loyout">
      {/* <Loader isLoad={isLoading} /> */}
      <div className="dashboard">
        <h1 className="mn_hdng">{id ? t.main.editVendor : null}</h1>
        <Button
          className="btn btn_primary"
          onClick={() => {
            navigate("/manage-vendors");
          }}
        >
          {t.main.back}
        </Button>
      </div>
      <Card className="cards">
        <form onSubmit={formik.handleSubmit}>
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2}>
              {/* <Grid item xs={12} className="heading"> */}
              {/* <Typography className="custom_label" variant="h5">
                  Agent Details
                </Typography> */}
              {/* </Grid> */}
              <Grid item xs={12}>
                <Typography className="custom_label">
                  {t.main.image} *
                </Typography>
                {formik.values.profile_picture ? (
                  <div className="upload_image_preview">
                    <CardMedia
                      component="img"
                      image={formik.values.profile_picture}
                      alt="photo"
                    />
                    <CancelIcon
                      onClick={(e) => {
                        e.preventDefault();
                        setProfilePicture("");
                        formik.setFieldValue("profile_picture", "");
                      }}
                    />
                  </div>
                ) : (
                  <Box className="upload_image">
                    <label htmlFor="icon-button-file">
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file"
                        type="file"
                        inputProps={{
                          accept: "image/png,image/jpeg",
                        }}
                        onChange={handleImageUpload}
                      />
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/user_placeholder.png" alt="" />
                        <CameraAltIcon />
                      </Button>
                    </label>
                  </Box>
                )}
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">
                  {t.main.fullName} *
                </Typography>

                <TextField
                  hiddenLabel
                  type="text"
                  className="text_field"
                  name="name"
                  variant="outlined"
                  fullWidth
                  placeholder={t.main.fullName}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">
                  {t.main.email} *
                </Typography>

                <TextField
                  hiddenLabel
                  className="text_field"
                  type="email"
                  name="email"
                  variant="outlined"
                  fullWidth
                  placeholder={t.main.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  disabled={true}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <Typography className="custom_label">
                  {t.main.phoneNumber} *
                </Typography>
                <PhoneInput
                  value={dialCode + formik.values.phone}
                  country={"ae"}
                  placeholder="0 (000) 000-000"
                  enableSearch={true}
                  inputStyle={{
                    width: "100%",
                    direction: getLang === "ar" ? "rtl" : "ltr",
                    paddingRight: getLang === "ar" ? "80px" : "0px",
                  }}
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  buttonStyle={{
                    marginRight: getLang === "ar" ? "40px" : "0px",
                  }}
                  onBlur={formik.handleBlur}
                  disabled={true}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <h6 className="err_msg">
                    {formik.touched.phone && formik.errors.phone.toString()}
                  </h6>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">
                  {t.main.businessName} *
                </Typography>

                <TextField
                  hiddenLabel
                  className="text_field"
                  type="text"
                  name="businessName"
                  variant="outlined"
                  fullWidth
                  placeholder={t.main.businessName}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.businessName}
                  error={
                    formik.touched.businessName &&
                    Boolean(formik.errors.businessName)
                  }
                  helperText={
                    formik.touched.businessName && formik.errors.businessName
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <div className="control_group w_50">
                  <Typography className="custom_label">
                    {t.main.industryType} *
                  </Typography>
                  <Select
                    labelId="category-label"
                    value={formik.values.industry_type || ""}
                    id="category-select"
                    name="industry_type"
                    fullWidth
                    displayEmpty
                    onChange={(e) => {
                      // formik.setFieldValue("city", "");
                      // handleValueChange({ key: 'country', value: e.target.value });
                      formik.setFieldValue("industry_type", e.target.value);
                    }}
                  >
                    <MenuItem value={""} disabled>
                      {t.main.selectIndustry}
                    </MenuItem>
                    {INDUSTRY_TYPE?.length
                      ? INDUSTRY_TYPE?.map(
                          (item: any, index: number) =>
                            item?.value && item?.label ? (
                              <MenuItem value={item.value} key={index}>
                                {item.label}
                              </MenuItem>
                            ) : null // Skip items without value or label
                        )
                      : ""}
                  </Select>
                </div>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <div className="control_group w_50">
                  <Typography className="custom_label">
                    {t.main.address} *
                  </Typography>
                  <TextField
                    hiddenLabel
                    type="text"
                    className="text_field"
                    name="address"
                    variant="outlined"
                    fullWidth
                    placeholder={t.main.address}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.address}
                    error={
                      formik.touched.address && Boolean(formik.errors.address)
                    }
                    helperText={formik.touched.address && formik.errors.address}
                  />
                  {/* <Autocomplete
                    onLoad={onLoad}
                    onPlaceChanged={() => onPlaceChanged()}
                  >
                    <TextField
                      className="text_field"
                      hiddenLabel
                      name="address"
                      value={formik.values?.address}
                      placeholder="Enter Address"
                      fullWidth
                      helperText={
                        formik.touched.address &&
                        typeof formik.errors.address === "string"
                          ? formik.errors.address
                          : undefined
                      }
                      onChange={(e) => {
                        if (
                          e.target.value.trim() === "" ||
                          e.target.value === "."
                        ) {
                          formik.setFieldValue("address", "");
                        } else {
                          formik.handleChange(e);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Autocomplete> */}
                </div>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <div className="control_group w_50">
                  <Typography className="custom_label">
                    {t.main.pinCode} *
                  </Typography>
                  <TextField
                    hiddenLabel
                    type="text"
                    className="text_field"
                    name="pin_code"
                    variant="outlined"
                    fullWidth
                    placeholder={t.main.pinCode}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.pin_code}
                    error={
                      formik.touched.pin_code && Boolean(formik.errors.pin_code)
                    }
                    helperText={
                      formik.touched.pin_code && formik.errors.pin_code
                    }
                  />
                  {/* <Autocomplete
                    onLoad={onLoad}
                    onPlaceChanged={() => onPlaceChanged()}
                  >
                    <TextField
                      className="text_field"
                      hiddenLabel
                      name="address"
                      value={formik.values?.address}
                      placeholder="Enter Address"
                      fullWidth
                      helperText={
                        formik.touched.address &&
                        typeof formik.errors.address === "string"
                          ? formik.errors.address
                          : undefined
                      }
                      onChange={(e) => {
                        if (
                          e.target.value.trim() === "" ||
                          e.target.value === "."
                        ) {
                          formik.setFieldValue("address", "");
                        } else {
                          formik.handleChange(e);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Autocomplete> */}
                </div>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">
                  {t.main.city} *
                </Typography>

                <TextField
                  hiddenLabel
                  className="text_field"
                  type="text"
                  name="city"
                  variant="outlined"
                  fullWidth
                  placeholder={t.main.city}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.city}
                  error={formik.touched.city && Boolean(formik.errors.city)}
                  helperText={formik.touched.city && formik.errors.city}
                />
              </Grid>
              {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">
                  Company Location
                </Typography>

                <TextField
                  hiddenLabel
                  type="text"
                  className="text_field"
                  name="companyLocation"
                  variant="outlined"
                  fullWidth
                  placeholder="Full address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.companyLocation}
                  error={
                    formik.touched.companyLocation &&
                    Boolean(formik.errors.companyLocation)
                  }
                  helperText={
                    formik.touched.companyLocation &&
                    formik.errors.companyLocation
                  }
                />
              </Grid> */}
            </Grid>
            <div className="form_btn">
              <Button
                size="large"
                type="submit"
                className="btn btn_primary"
                onClick={() => setError(true)}
              >
                {t.main.update}
              </Button>
            </div>
          </CardContent>
        </form>
      </Card>
    </div>
  );
};

export default ProfileSetup;
